import React from 'react';
import { TruckIcon, ShieldCheckIcon, CreditCardIcon, HeadphonesIcon } from 'lucide-react';
export function CheckoutFooter() {
  const benefits = [{
    icon: <TruckIcon className="w-5 h-5" data-id="element-2146" data-mp="1tqjons3u76vw" />,
    title: 'Free Delivery',
    description: 'On orders over SAR 100'
  }, {
    icon: <ShieldCheckIcon className="w-5 h-5" data-id="element-2147" data-mp="1jqsy21iedc13" />,
    title: 'Secure Payment',
    description: '100% secure transactions'
  }, {
    icon: <CreditCardIcon className="w-5 h-5" data-id="element-2148" data-mp="2hcypjfps42iy" />,
    title: 'Easy Returns',
    description: '30-day return policy'
  }, {
    icon: <HeadphonesIcon className="w-5 h-5" data-id="element-2149" data-mp="27now9wj78dt9" />,
    title: '24/7 Support',
    description: 'Dedicated support team'
  }];
  return <footer className="bg-white border-t border-gray-200 py-6 mt-8" data-id="element-2150" data-mp="22o2i9kvjqtje">
      {/* Benefits Bar - Desktop Only */}
      <div className="hidden md:block container mx-auto px-4 mb-6" data-id="element-2151" data-mp="305u8nfucjm5j">
        <div className="flex items-center justify-center gap-8" data-id="element-2152" data-mp="2vd9hkm2trn5p">
          {benefits.map((benefit, index) => <div key={index} className="flex items-center gap-3" data-id="element-2153" data-mp="ai9l7abb6f76" data-mpi={index}>
              <div className="flex-shrink-0 w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center text-[#1E2B55]" data-id="element-2154" data-mp="ej38c1gxfpz0">
                {benefit.icon}
              </div>
              <div data-id="element-2155" data-mp="5q9qbwa3ichg">
                <p className="text-sm font-bold text-gray-900" data-id="element-2156" data-mp="5pq6ga0vxe0s">
                  {benefit.title}
                </p>
                <p className="text-xs text-gray-600" data-id="element-2157" data-mp="3mxbtwpl17gho">{benefit.description}</p>
              </div>
            </div>)}
        </div>
      </div>
      {/* Footer Content */}
      <div className="container mx-auto px-4" data-id="element-2158" data-mp="3dy8a1je1ix24">
        <div className="text-center text-sm text-gray-600" data-id="element-2159" data-mp="3dzjdtj7hk4t8">
          <p data-id="element-2160" data-mp="3iw02qfmien7d">© 2024 Innova Pharmacy. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}